import { createContext } from "react";

export const PopoverContext = createContext({
  closePopover: () => {},
});
